import React from "react";

import { Theme } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Tooltip } from "@shared/Tooltip";

type LinkComponentProps = {
    children?: React.ReactNode;
    onClick: () => void;
    tooltip: string;
};

const getClickableLabelStyle = (theme: Theme): React.CSSProperties => ({
    cursor: "pointer",
    marginBottom: theme.spacing(1),
    color: theme.palette.emteria.link,
});

export const ClickableLink = ({ children, onClick, tooltip }: LinkComponentProps) => {
    const theme = useTheme();
    return (
        <Tooltip title={tooltip} placement="top">
            <span
                onClick={onClick}
                style={getClickableLabelStyle(theme)}
                onMouseEnter={(e) => {
                    e.currentTarget.style.color = theme.palette.emteria.warning;
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.color = theme.palette.emteria.link;
                }}
            >
                {children}
            </span>
        </Tooltip>
    );
};
